/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {FormTextField} from '@ion/dls/src/components/forms/FormTextField';
import {dlsColor} from '@ion/dls/src/theme/theme';

type SaveSettingsActionsProps = {
  description?: string;
  geofenceName?: string;
  translations?: any;
  handleDescription?: (e: {target: any}) => void;
  handleGeofenceName?: (e: {target: any}) => void;
};

const textFieldStyleOverrides = () => ({
  fieldLabel : {
    '&&' : {
      marginTop  : '10px',
      marginLeft : '6px'
    }
  }
});

const useStyles = makeStyles(() => {
  return {
    geofenceWrapper : {
      marginLeft : '15px',
      width      : 'calc(100% - 24px)'
    },
    rootStyle : {
      gap             : '8px',
      border          : `1px solid ${dlsColor('grey6')}`,
      height          : '49px',
      display         : 'flex',
      padding         : '8px 16px 8px 16px',
      borderRadius    : '8px',
      backgroundColor : dlsColor('white')
    }
  };
});

const SaveSettingsActions = ({
  description,
  geofenceName,
  translations,
  handleDescription,
  handleGeofenceName
}: SaveSettingsActionsProps) => {
  const classes = useStyles();

  return (
    <>
      <FormTextField fieldLabel={translations.geofenceName}
        className={classes.geofenceWrapper}
        value={geofenceName}
        styleOverrides={textFieldStyleOverrides}
        InputProps={{classes: {root: classes.rootStyle}}}
        placeholder={translations.geofencePlaceholder}
        onChange={handleGeofenceName} />
      <FormTextField fieldLabel={translations.description}
        className={classes.geofenceWrapper}
        value={description}
        styleOverrides={textFieldStyleOverrides}
        InputProps={{classes: {root: classes.rootStyle}}}
        inputProps={{maxLength: 500}}
        placeholder={translations.descriptionPlaceholder}
        onChange={handleDescription} />
    </>
  );
};

export default React.memo(SaveSettingsActions);
